import React, { Component } from "react";
import { Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import axiosInstance from "../../axios-project";

class RoleModal extends Component {
  state = {
    password: null
  };
  handleSubmit = e => {
    e.preventDefault();

    console.log("user/" + this.props.currentUserID);
    axiosInstance
      .put("user/" + this.props.currentUserID, {
        password: this.state.password
      })
      .then(response => {
        console.log("Success");
        this.props.fetchAdminDetails();
      })
      .catch(error => {
        console.log(error);
      });
  };
  handleChange = e => {
    this.setState({ password: e.target.value });
  };
  render() {
    return (
      <Modal
        id="password_modal"
        isOpen={this.props.modal}
        fade
        toggle={this.props.toggle}
        backdrop="static"
      >
        <div className="modal-content">
          <ModalHeader toggle={this.props.toggle}>Change Password</ModalHeader>
          <ModalBody>
            <form
              autoComplete="off"
              className="form"
              id="userForm"
              name="userForm"
              onSubmit={this.handleSubmit}
            >
              <small className={"d-block"}>
                <span style={{ color: "red" }}>*</span> required
              </small>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                className="form-control"
                onChange={this.handleChange}
                value={this.state.password}
              />

              <div className="form-group my-3">
                <Button
                  color="primary"
                  type="submit"
                  className="float-left mx-2"
                  onClick={this.props.toggle}
                >
                  Submit
                </Button>
                <Button
                  color="secondary"
                  type="button"
                  className="float-left"
                  onClick={this.props.toggle}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </ModalBody>
        </div>
      </Modal>
    );
  }
}

export default RoleModal;
